import { Link } from "react-router-dom";
import { useState } from "react";
import AuthNavButton from "./AuthNavButton";
import DomainNavLink from "./DomainNavLink";
import { prefetchTherapists } from "../utils/prefetchTherapists";

const navClass = "text-[#203C2E] hover:text-[#2B5A41] font-medium transition-colors";
const navBlockClass = "block text-[#203C2E] hover:text-[#2B5A41] font-medium transition-colors";

const AppHeader: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    return (
        <header className="cb-page fixed top-0 left-0 right-0 bg-[#F5F6F0]/95 backdrop-blur-md border-b border-[#E0EDE3] z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center">
                        <DomainNavLink to="/" className="text-[#203C2E] hover:text-[#2B5A41] font-medium transition-colors" onClick={closeMenu}>
                            <img
                                src="/assets/logo.png"
                                alt="Constela Brasil"
                                className="h-10 w-auto"
                            />
                        </DomainNavLink>
                    </div>

                    <nav className="hidden md:flex items-center space-x-8">
                        <DomainNavLink to="/" className={navClass}>Home</DomainNavLink>
                        <DomainNavLink to="/sobre-nos" className={navClass}>Sobre Nós</DomainNavLink>
                        <DomainNavLink to="/terapeutas" className={navClass} onMouseEnter={prefetchTherapists}>Terapeutas</DomainNavLink>
                        <DomainNavLink to="/quero-participar" className={navClass}>Agendar</DomainNavLink>
                        <DomainNavLink to="/planos" className={navClass}>Planos</DomainNavLink>
                        <DomainNavLink to="/tutoriais" className={navClass}>Tutoriais</DomainNavLink>
                        <DomainNavLink to="/contato" className={navClass}>Contato</DomainNavLink>
                        <DomainNavLink to="/constelador" className="text-[#89A78C] hover:text-[#203C2E] font-semibold transition-colors">
                            Sou Constelador
                        </DomainNavLink>
                        <AuthNavButton />
                    </nav>

                    <div className="md:hidden flex items-center gap-2 shrink-0">
                        <AuthNavButton compact />
                        <button
                            onClick={toggleMenu}
                            className="text-[#203C2E] hover:text-[#2B5A41] focus:outline-none"
                            aria-label="Toggle menu"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
                            </svg>
                        </button>
                    </div>
                </div>

                {isMenuOpen && (
                    <div className="md:hidden bg-[#F5F6F0]/95 backdrop-blur-md border-t border-[#E0EDE3]">
                        <nav className="px-4 py-4 space-y-4">
                            <DomainNavLink to="/" className={navBlockClass} onClick={closeMenu}>Home</DomainNavLink>
                            <DomainNavLink to="/sobre-nos" className={navBlockClass} onClick={closeMenu}>Sobre Nós</DomainNavLink>
                            <DomainNavLink to="/terapeutas" className={navBlockClass} onClick={closeMenu} onMouseEnter={prefetchTherapists}>Terapeutas</DomainNavLink>
                            <DomainNavLink to="/quero-participar" className={navBlockClass} onClick={closeMenu}>Agendar</DomainNavLink>
                            <DomainNavLink to="/planos" className={navBlockClass} onClick={closeMenu}>Planos</DomainNavLink>
                            <DomainNavLink to="/tutoriais" className={navBlockClass} onClick={closeMenu}>Tutoriais</DomainNavLink>
                            <DomainNavLink to="/contato" className={navBlockClass} onClick={closeMenu}>Contato</DomainNavLink>
                            <DomainNavLink to="/constelador" className="block text-[#89A78C] hover:text-[#203C2E] font-semibold transition-colors" onClick={closeMenu}>
                                Sou Constelador
                            </DomainNavLink>
                            <div className="pt-2">
                                <AuthNavButton isMobile={true} />
                            </div>
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
}

export default AppHeader;
